var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParallel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "10px",
    width: "8px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.602 15.602",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c97_pause"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.155,0h2.961c0.191,0,0.352,0.161,0.352,0.354v14.893c0,0.195-0.16,0.355-0.352,0.355h-2.961 c-0.191,0-0.355-0.16-0.355-0.355V0.354C9.8,0.161,9.964,0,10.155,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.488,0h2.963c0.191,0,0.35,0.161,0.35,0.354v14.893c0,0.195-0.158,0.355-0.35,0.355H2.488 c-0.196,0-0.354-0.161-0.354-0.356V0.354C2.134,0.161,2.292,0,2.488,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_73_"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParallel);
export default __webpack_public_path__ + "static/media/parallel.f5fe6e5b83eca3444a81673f0d32caca.svg";
export { ForwardRef as ReactComponent };